import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';

export function useSubmitSeagForm() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      const { data } = await apiClient.post('/partner-request/seag', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data;
    },
  });
}
